import { useState } from 'react';
import { truncateString, stringLengthMax } from '../../utils/utilFunctions';

import StyledWrapper from './style';

import Tooltip from '@mui/material/Tooltip';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ReviewFormIcon from '../../assets/customIcons/reviewForm.jsx';
import { getStatusColor } from '../../utils/utilFunctions';
import VerticalNavLink from './VerticalNavLink';

const ReviewsDropdown = ({
	item,
	active,
	text,
	onClick,
	lastChild,
	formId,
	masterLink,
	status
}) => {
	const [expanded, setExpanded] = useState(text);
	const url = window.location.href;
	const isActive = `${formId}-group` === active || url.includes(`${formId}-group/details`);

	return (
		<StyledWrapper.DropdownContainer
			expanded={expanded === `${text}`}
			TransitionProps={{ unmountOnExit: true }}
			isChild={true}
			lastChild={lastChild}
			active={isActive}
		>
			<AccordionSummary
				aria-controls={`${text}-content`}
				id={`${text}-header`}
				sx={{
					minHeight: '24px!important',
					paddingBottom: expanded && '10px!important'
				}}
			>
				{expanded ? (
					<StyledWrapper.MinusIcon onClick={() => setExpanded(false)} />
				) : (
					<StyledWrapper.PlusIcon onClick={() => setExpanded(text)} />
				)}
				<ReviewFormIcon isActive={true} customColor={getStatusColor(status)} />

				<Tooltip title={text.length > stringLengthMax ? text : ''} arrow placement="top">
					<StyledWrapper.NavLink onClick={() => onClick(masterLink)} active={isActive}>
						{truncateString(text)}
					</StyledWrapper.NavLink>
				</Tooltip>
			</AccordionSummary>
			<AccordionDetails
				sx={{ display: 'flex', flexDirection: 'column', gap: '5px', marginLeft: '50px' }}
			>
				{item?.map((e, index) => (
					<VerticalNavLink
						status={e?.status}
						currentStage={e?.is_current_stage}
						key={`${index}-${e?.title}`}
						isReview={true}
						active={
							url.includes(`${e?.id}`) ||
							active === e?.id?.toLowerCase() ||
							active === e?.title?.toLowerCase()
						}
						isChild={true}
						text={e?.title}
						onClick={() => onClick(e?.link || e?.id)}
						external={false}
					/>
				))}
			</AccordionDetails>
		</StyledWrapper.DropdownContainer>
	);
};

export default ReviewsDropdown;
